<template>
  <!-- 合同基本信息 -->
  <div class="app-container">
    <van-cell-group>
      <van-cell title="客户名称" :value="item.khmc" size="large" />
      <van-cell title="合同编号：" :value="item.htbh" size="large" />
      <van-cell title="合同金额（元）：" :value="item.htjj" size="large" />
      <van-cell title="合同剩余金额（元）：" :value="item.syje" size="large" />
      <van-cell title="合同日期：" :value="item.fkrq" size="large" />
      <van-cell title="总期数：" :value="item.zqs" size="large" />
      <van-cell
        title="还款方式："
        :value="hkfsFormatter(item.hkfs)"
        size="large"
      />
      <van-cell
        title="业务状态："
        :value="zlywztFormatter(item.zlywzt)"
        size="large"
      />
    </van-cell-group>
  </div>
</template>

<script>
import { Cell, CellGroup } from "vant";
import { hkfsFormatter, zlywztFormatter } from "@/utils/formatter.js";
export default {
  name: "LeaseDetail",
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  data() {
    return {
      item: this.$route.query
    };
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    hkfsFormatter(hkfs) {
      return hkfsFormatter(hkfs);
    },
    zlywztFormatter(zlywzt) {
      return zlywztFormatter(zlywzt);
    }
  },
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.app-container {
  width: 100%;
  color: rgba(0, 0, 0, 0.5);
}
</style>
